import { normalizePopupId } from './popupEvents';

export const CTA_ACTIONS = ['link', 'video', 'download', 'popup'] as const;

/**
 * What activating a CTA does: `link` navigates to its href, `video` opens the href in a video
 * modal, `download` downloads the href when the browser permits it, and `popup` opens the Popup
 * block whose id matches the CTA's popup target id.
 */
export type CtaAction = (typeof CTA_ACTIONS)[number];

/** Whether an authored CTA has the destination its selected action requires. */
export const hasCtaDestination = (
  href: string | undefined,
  action: CtaAction | undefined,
  popupTargetId: string | undefined,
): boolean => action === 'popup' ? Boolean(normalizePopupId(popupTargetId)) : Boolean(href);
